import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import FormationIA from "@/pages/FormationIA";
import FormationNoCode from "@/pages/FormationNoCode";
import FormationHygiene from "@/pages/FormationHygiene";
import Livres from "@/pages/Livres";
import DicoIA from "@/pages/DicoIA";
import TablechoPage from "@/pages/TablechoPage";
import QuiSuisJe from "@/pages/QuiSuisJe";
import References from "@/pages/References";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/formations/ia-prompt-engineering" element={<FormationIA />} />
          <Route path="/formations/automatisation-no-code" element={<FormationNoCode />} />
          <Route path="/formations/hygiene-pms" element={<FormationHygiene />} />
          <Route path="/livres" element={<Livres />} />
          <Route path="/dico-ia" element={<DicoIA />} />
          <Route path="/tablecho" element={<TablechoPage />} />
          <Route path="/qui-suis-je" element={<QuiSuisJe />} />
          <Route path="/references" element={<References />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
